import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FlashCardItem, getCategoryCards } from '../../api/leagues';
import '../../styles/global.css';

const ViewFlashCards: React.FC = () => {
  const navigate = useNavigate();
  const { leagueId, categoryId } = useParams<{ leagueId: string; categoryId: string }>();
  const [categoryName, setCategoryName] = useState('');
  const [cards, setCards] = useState<FlashCardItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchCards = async () => {
      const token = localStorage.getItem('manager_token');
      if (!token || !leagueId || !categoryId) {
        navigate('/manager');
        return;
      }
      localStorage.setItem('token', token);
      try {
        const result = await getCategoryCards(leagueId, categoryId);
        setCategoryName(result.category_name);
        setCards(result.cards);
      } catch (err: any) {
        setError(err.response?.data?.detail || 'Failed to load flash cards');
      } finally {
        localStorage.removeItem('token');
        setLoading(false);
      }
    };
    fetchCards();
  }, [leagueId, categoryId, navigate]);

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="page">
      <nav className="navbar">
        <div className="nav-brand">
          <button
            className="link-btn"
            onClick={() => navigate(-1)}
            style={{ marginRight: '10px' }}
          >
            &larr; Back
          </button>
          {categoryName} ({cards.length} cards)
        </div>
      </nav>

      <div className="container">
        {error && <div className="error" style={{ marginBottom: '20px' }}>{error}</div>}

        {cards.length === 0 ? (
          <div className="card">
            <p className="placeholder-text">No flash cards in this category.</p>
          </div>
        ) : (
          <div className="card">
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #eee' }}>
                    <th style={{ padding: '8px 4px', textAlign: 'left', width: '30px' }}>#</th>
                    <th style={{ padding: '8px 4px', textAlign: 'left' }}>Question</th>
                    <th style={{ padding: '8px 4px', textAlign: 'left' }}>Correct Answer</th>
                    <th style={{ padding: '8px 4px', textAlign: 'left' }}>Wrong Answers</th>
                  </tr>
                </thead>
                <tbody>
                  {cards.map((card, i) => (
                    <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '6px 4px', color: '#666' }}>{i + 1}</td>
                      <td style={{ padding: '6px 4px' }}>{card.question}</td>
                      <td style={{ padding: '6px 4px', fontWeight: 'bold', color: '#28a745' }}>
                        {card.correct_answer}
                      </td>
                      <td style={{ padding: '6px 4px', color: '#dc3545' }}>
                        {card.wrong_answers.join(', ')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewFlashCards;
